import SectionShell from "./SectionShell";
import FieldGroup from "./FieldGroup";
import ToggleSwitch from "../../Setting/components/printers/ToggleSwitch";
import { inputClass } from "./styles";

const LanguagesSection = ({
  languages,
  isLoading,
  newLang,
  langErrors,
  onNewLangChange,
  onAddLanguage,
  onToggleLanguage,
}) => {
  return (
    <SectionShell
      number="2"
      title="Languages"
      subtitle="Manage available languages and enable/disable them."
    >
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2">
          <div className="flex items-center justify-between mb-3">
            <div className="text-xs font-semibold text-gray-500 uppercase tracking-widest">
              Added Languages
            </div>
            {isLoading ? (
              <div className="text-xs text-gray-500">Loading...</div>
            ) : null}
          </div>
          <div className="border border-gray-100 rounded-xl overflow-x-auto">
            <table className="w-full min-w-[500px] text-sm">
              <thead className="bg-gray-50">
                <tr className="text-left text-xs text-gray-500 uppercase tracking-widest">
                  <th className="px-4 py-3">Code</th>
                  <th className="px-4 py-3">Name</th>
                  <th className="px-4 py-3">Direction</th>
                  <th className="px-4 py-3">Status</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-100">
                {(languages || []).length === 0 ? (
                  <tr>
                    <td className="px-4 py-4 text-gray-500" colSpan={4}>
                      No languages found.
                    </td>
                  </tr>
                ) : (
                  languages.map((l) => (
                    <tr key={l.code} className="bg-white">
                      <td className="px-4 py-3 font-semibold text-gray-900">
                        {(l.code || "").toUpperCase()}
                      </td>
                      <td className="px-4 py-3 text-gray-700">{l.name}</td>
                      <td className="px-4 py-3 text-gray-700">
                        {(l.direction || "ltr").toUpperCase()}
                      </td>
                      <td className="px-4 py-3 flex ">
                        <ToggleSwitch
                          checked={!!l.isActive}
                          onChange={() => onToggleLanguage(l.code)}
                          labelOn="Enabled"
                          labelOff="Disabled"
                        />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        <div>
          <div className="text-xs font-semibold text-gray-500 uppercase tracking-widest mb-3">
            Add Language
          </div>
          <div className="space-y-4">
            <FieldGroup label="Code (e.g. ar, hi, fr)">
              <input
                className={`${inputClass} ${langErrors.code ? "border-red-500 focus:border-red-500" : ""}`}
                value={newLang.code}
                onChange={(e) => onNewLangChange("code", e.target.value)}
                placeholder="en"
              />
              {langErrors.code && (
                <p className="text-xs text-red-500 mt-1">{langErrors.code}</p>
              )}
            </FieldGroup>
            <FieldGroup label="Name">
              <input
                className={`${inputClass} ${langErrors.name ? "border-red-500 focus:border-red-500" : ""}`}
                value={newLang.name}
                onChange={(e) => onNewLangChange("name", e.target.value)}
                placeholder="English"
              />
              {langErrors.name && (
                <p className="text-xs text-red-500 mt-1">{langErrors.name}</p>
              )}
            </FieldGroup>
            <FieldGroup label="Direction">
              <select
                className={inputClass}
                value={newLang.direction}
                onChange={(e) => onNewLangChange("direction", e.target.value)}
              >
                <option value="ltr">LTR</option>
                <option value="rtl">RTL</option>
              </select>
            </FieldGroup>
            <button
              type="button"
              onClick={onAddLanguage}
              className="w-full bg-black hover:bg-gray-900 text-white px-4 py-2.5 rounded-xl text-sm font-semibold active:scale-[0.98] transition-all duration-200"
            >
              Add Language
            </button>
          </div>
        </div>
      </div>
    </SectionShell>
  );
};

export default LanguagesSection;